<template>
  <div class="tables-container">
    <div :class="`gap-histories-table gap-histories-table-${_uid}`">
      <!-- Tranche Update Table -->
      <b-table small
               :items="filteredGapHistories"
               :fields="fields"
               :sort-by="sortBy"
               :sort-desc="sortDesc"
               show-empty
               empty-text="Aucun état actuellement"
               v-if="filteredGapHistories.length > 0">

        <!-- Date -->
        <template slot="updatedAt" slot-scope="row">
          {{  formatDate(row.item.updatedAt) }}
        </template>

        <!-- Agent -->
        <template slot="agent" slot-scope="row">
          {{  row.item.agent.firstName !== null ? row.item.agent.firstName : 'NR' }} {{  row.item.agent.lastName !== null ? row.item.agent.lastName : 'NR' }}
        </template>

        <!-- Gaps -->
        <template slot="gaps" slot-scope="row">
            {{ formatGaps(row.item.gaps) }}
        </template>

        <!-- Edit -->
        <template slot="edit" slot-scope="row">
          <a href="#!" @click.stop.prevent="openModal(row.item.gaps)" class="mr-2"><icon name="eye" scale="1"/></a>
          <ShowGapHistoryTypeButton title="Aléa" :id="row.item.id" :tranche="row.item.tranche" v-if="isAdmin() || isAgent()"/>
        </template>
      </b-table>
      <p v-else>
        Il n'y a aucun aléa pour ce dossier.
      </p>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-underscore-dangle */
import { EventBus } from '../../event-bus.js';
import { mapGetters } from 'vuex';
import Clone from 'clone';

const moment = require('moment');
const $ = require('jquery');

export default {
  name: 'GapHistoriesTable',
  props: {
    gapHistories: {
      type: Array,
      default() {
        const gapHistories = [];
        return gapHistories;
      },
    },
  },
  data() {
    return {
      tableHeadHeight: 0,
      tableFootHeight: 0,
      heightContainerEditButtonWidthList: [],
      sortBy: "updatedAt",
      sortDesc: false,
    };
  },
  watch: {
    getResizeWidth() {
      this.handleButtonEditCss();
    },
    filteredGapHistories() {
      setTimeout(() => {
        this.setHeightContainerEditButtonList();
      });
    },
  },
  computed: {
    ...mapGetters({
      getResizeWidth: 'getResizeWidth',
    }),
    filteredGapHistories() {
      return this.gapHistories
        .filter(g => !g.archived)
        .map((g) => {
          const newGapHistory = Clone(g);
          return newGapHistory;
        })
        .sort((a, b) => {
          const isBefore = moment(a.updatedAt, 'YYYY-MM-DD HH:mm:ss').isBefore(moment(b.updatedAt, 'YYYY-MM-DD HH:mm:ss'));
          return isBefore ? 1 : -1;
        });
    },
    fields() {
      // Get the viewport type (xs,sm,md,lg,xl)
      const viewPortSize = this.getViewPortSize();
      // Fields table
      const computedFields = {
        updatedAt: {
          label: 'Date',
          sortable: true,
        },
        agent: 'Agent',
        gaps: 'Écarts',
        edit: ' ',
      };
      // According to the size, some fields are deleted to make the table responsive
      if (viewPortSize === 'xs') {
        delete computedFields.agent;
      } else if (viewPortSize === 'sm') {
        // delete computedFields.?;
      } else if (viewPortSize === 'md') {
        // delete computedFields.?;
      } else if (viewPortSize === 'lg') {
        // delete computedFields.?;
      }
      return computedFields;
    },
  },
  methods: {
    ...mapGetters([
      'getViewPortSize',
      'isAdmin',
      'isAgent',
      'isAgency',
    ]),
    handleButtonEditCss() {
      this.tableHeadHeight = `${$(`.gap-histories-table-${this._uid} th`).outerHeight()}px`;
      this.tableFootHeight = '17px';// `${$('.gap-histories-table tfoot').outerHeight() + 17}px`;
      this.setHeightContainerEditButtonList();
    },
    setHeightContainerEditButtonList() {
      const list = [];
      $(`.gap-histories-table-${this._uid} tr`).each((i, el) => {
        if (i > 0) {
          list.push(`${$(el).outerHeight()}px`);
        }
      });
      // console.log('Height list : ', list);
      this.heightContainerEditButtonWidthList = list;
    },
    formatDate(date) {
      return moment(date, 'YYYY-MM-DD HH:mm').format('DD/MM/YYYY');
    },
    formatGaps(gaps) {
      return gaps.map(g => `${g.code}`).join(' - ');
    },
    openModal(gaps) {
      EventBus.$emit('openGapsModal', gaps);
    },
  },
  mounted() {
    // Get the table head height to align edit button vertically
    $(() => {
      this.handleButtonEditCss();
    });
  },
  updated() {
    $(() => {
      this.handleButtonEditCss();
    });
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  .tables-container {
    display: flex;
    flex-flow: row nowrap;

    .edit-gap-history-btn-col {

      .edit-gap-history-btn {
        display: flex;
        flex-flow: column nowrap;
        justify-content: space-around;
        margin-left: 15px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/tables/GapHistoriesTable.vue